import { onPageVisibility } from '../lib';

// Phaser stops sound on window blur. Phones often skip that.

/** Only the bits used here, so this stays off Phaser's types. */
type PhaserSound = {
  isPlaying: boolean;
  loop: boolean;
  pause: () => void;
  resume: () => void;
  stop: () => void;
};

type PhaserGame = {
  // The no-audio manager fills `sounds` without declaring it.
  sound: object;
  events: { once: (event: string, listener: () => void) => unknown };
};

const soundsOf = (manager: object): PhaserSound[] =>
  (manager as { sounds?: PhaserSound[] }).sounds ?? [];

/** Call once, right after the game is made. Returns the unhook. */
export function pauseSoundWhenHidden(game: PhaserGame): () => void {
  let stopped: PhaserSound[] = [];

  const off = onPageVisibility({
    // Remember them, so we restart only what we stopped.
    hidden: () => {
      stopped = soundsOf(game.sound).filter((sound) => sound.isPlaying);
      stopped.forEach((sound) => sound.pause());
    },
    // Music carries on. A cue does not.
    visible: () => {
      stopped.forEach((sound) => (sound.loop ? sound.resume() : sound.stop()));
      stopped = [];
    },
  });

  // Phaser.Core.Events.DESTROY, by name to skip the import.
  game.events.once('destroy', off);
  return off;
}
